import { combineReducers } from "redux";
// import TaskJobType from "./taskJobType";
// import TaskJob from "./taskJob";
// import taskBasicData from "./taskBasicData";
import langReducer from "./langReducer";
import taskDynamic from "./taskDynamic";
import mapReducer from "./map.reducer";
import dynamicReducer from "./dynamicReducer";
import visibleReducer from "./visibleReducer";
import operationReducer from "./operationReducer";
import modulesReducer from "./modulesReducer";
import jobDetailReducer from "./jobDetailReducer";
import jobProgressdetailPicAction from "./jobProgressdetailPicReducer";
import notificationHistoryReducer from "./notificationHistoryReducer";
import fixProblemReducer from "./fixProblemReducer";
import fixProblemPic from "./fixProblemPicReducer";
import dynamicFunction from "./dynamicFunctionReducer";
import masterLang from "./masterLangReducer";
import metaData from "./metaDataReducer";
import repairPointReducer from "./repairPointReducers";

const rootReducer = combineReducers({
  lang: langReducer,
  masterLang: masterLang,
  task_dynamic: taskDynamic,
  mapReducer: mapReducer,
  dynamicReducer: dynamicReducer,
  visibleReducer: visibleReducer,
  operationReducer: operationReducer,
  modules: modulesReducer,
  jobDetail: jobDetailReducer,
  jobProgressPic: jobProgressdetailPicAction,
  fixProblemlist: fixProblemReducer,
  fixProblemPic: fixProblemPic,
  notificationHistory: notificationHistoryReducer,
  dynamicFunction: dynamicFunction,
  metaData: metaData,
  repairPoint: repairPointReducer,
});
export default rootReducer;

// export default combineReducers({
//     lang: langReducer ,
//     task_dynamic : taskDynamic
// });
